import { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  CkTextEditor,
  Divider,
  FormFieldSet,
  LogoLoader,
  MailRecipient,
  Modal,
  showToast,
} from "../../../../components";
  import { getEmailTemplate, mapTemplate } from "../../../../utils/wf/email";
import { useNavigate } from "react-router-dom";

const ResendModal = ({
  open,
  onClose,
  toEmail,
  ccEmail,
  bccEmail,
  handleSave,
  emailSubject = "",
  templateName = null,
  data = {},
  isMailSaving = false,
  timesheetDisable = false
}) => {
  const navigate = useNavigate();
  const [emails, setEmails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [subject, setSubject] = useState(emailSubject);
  const [body, setBody] = useState("");
  const [attachments, setAttachments] = useState(timesheetDisable ? [1] : [1,2]);
  console.log("Resend Modal", { emails, subject, body }, attachments);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true)
        if (!templateName) throw new Error("Template name is required");
        const resp = await getEmailTemplate({ name: templateName });
        const html = mapTemplate(resp?.body || "", data);
        setSubject(mapTemplate(resp?.subject || "", data));
        setBody(html);
      } catch (error) {
        console.error("Error fetching email template", error);
        showToast("Error occured while fetching the email template", "error", 5000);
      } finally {
        setIsLoading(false)
      }
    })();
  }, [templateName]);
  return (
    <>
      <div>
      <Modal
        isOpen={open}
        onClose={onClose}
        title="INVOICE EMAIL PREVIEW "
        width="max-w-7xl"
        zIndex={54}
        closeOnOutsideClick={true}
      >
        <div className="px-4">
          <div>
            <MailRecipient
              contactEmail={toEmail}
              ccEmail={ccEmail}
              bccEmail={bccEmail}
              getEmails={setEmails}
            />
          </div>
          <div className="mt-4">
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">Subject:</div>
              <div className="w-full">
                <input
                  type="text"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="w-full outline-0"
                />
                <Divider />
              </div>
            </div>
          </div>
          <div className="border-[1px] border-neutrals-50 rounded my-4 p-3 min-h-80">
            {/* <CkTextEditor value={body} onChange={setBody} /> */}
            <div dangerouslySetInnerHTML={{ __html: `${body}` }} />
          </div>
          <div className="border-[1px] border-neutrals-50 rounded my-4 p-3 min-h-20">
            <div className="flex items-center gap-4">
              <FormFieldSet
                type="checkbox"
                size={"md"}
                title="Include Attachments"
                options={[
                  {
                    label: "Invoice PDF",
                    value: 1,
                  },
                  ...(!timesheetDisable ? [{
                    label: "Timesheets Attachment PDF",
                    value: 2,
                  }] : [])
                ]}
                values={attachments}
                onChange={(value) => setAttachments(value)}
                multiple
              />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <Button title={"Cancel "} variant="outlined" onClick={onClose} />
            <Button
              title={"Send"}
              disabled={isMailSaving}
              onClick={() => handleSave({ subject, body, emails, attachments})}
            />
          </div>
        </div>
        <Backdrop isOpen={isMailSaving || isLoading}>
          <LogoLoader />
        </Backdrop>
      </Modal>
      </div>
    </>
      
  );
};

export default ResendModal;
